import React from 'react'

import { Intl, Localized } from '../../localization/react'

interface Props {
  isOrderConfirmed: boolean
  hasSelfCheckIn: boolean
  hasBooking: boolean
}

const ConfirmationSubHeading: React.FC<React.PropsWithChildren<Props>> = ({
  isOrderConfirmed,
  hasSelfCheckIn,
  hasBooking,
}): React.ReactElement<Intl> => {
  // there wasn't a booking of an activity but instead a purchase of a product or payment of an invoice
  if (!hasBooking) {
    return <Localized id="purchase-confirmation-sub-heading" />
  }

  // booking requested, but it hasn't yet been confirmed by the venue
  if (!isOrderConfirmed) {
    return <Localized id="booking-confirmation-sub-heading-no-confirmed" />
  }

  // booking has already been confirmed by the venue and it hasn't self-checkin
  if (!hasSelfCheckIn) {
    return <Localized id="booking-confirmation-sub-heading-without-self-check-in" />
  }

  // booking has already been confirmed by the venue and it has self-checkin
  return <Localized id="booking-confirmation-sub-heading" />
}

export default ConfirmationSubHeading
